import { serviceRoles } from "config/access";
import { JOURNAL } from "constants/routes";
import { checkAccess } from "helpers/auth";
import JournalPage from "./container/JournalPage";

export default function getSettingsRoute(userAuth) {
  const { account, rhapsody } = serviceRoles;
  const requireAuth = {
    [rhapsody.name]: [account.roles.user],
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: JOURNAL,
    withSidebar: true,
    withAppBar: true,
    component: JournalPage,
  };
}
